/*! @pentacode/ui v0.1.0 */
import "../../form-elements/select.js";
import { FormElement as e } from "../../formElement.js";
import { t } from "../../../styledElement-DUAqv8gi.js";
import { t as n } from "../../../decorateMetadata-BXz2gmG4.js";
import { t as r } from "../../../decorate-C_HUHFGG.js";
import { LitElement as i, html as a } from "lit";
import { customElement as o, property as s, state as c } from "lit/decorators.js";
// src/elements/employee-questionnaire/shared/education-section.ts
var l = [
	{
		label: "ohne Schulabschluss",
		value: "none"
	},
	{
		label: "Haupt - /Volksschulabschluss",
		value: "primary"
	},
	{
		label: "Mittlere Reife oder gleichwert. Abschluss",
		value: "secondary"
	},
	{
		label: "Abitur / Fachabitur",
		value: "higher"
	}
], u = [
	{
		label: "ohne beruflichen Abschluss",
		value: "none"
	},
	{
		label: "Abschluss einer anerkannten Berufsausbildung",
		value: "apprenticeship"
	},
	{
		label: "Meister-/Techniker oder gleichw. Fachschulabschluss",
		value: "technician"
	},
	{
		label: "Bachelor",
		value: "bachelor"
	},
	{
		label: "Diplom/Magister/Master/Staatsexamen",
		value: "diploma/master"
	},
	{
		label: "Promotion",
		value: "doctoral"
	}
], d = class extends t(e(i)) {
	constructor(...e) {
		super(...e), this.data = {}, this._schoolEducation = "none", this._professionalEducation = "none";
	}
	willUpdate(e) {
		e.has("data") && this.data && (this._schoolEducation = this.data.schoolEducation ?? "none", this._professionalEducation = this.data.professionalEducation ?? "none");
	}
	_handleSectionChange() {
		this.dispatchEvent(new CustomEvent("change", {
			detail: {
				schoolEducation: this._schoolEducation,
				professionalEducation: this._professionalEducation
			},
			bubbles: !0,
			composed: !0
		}));
	}
	render() {
		return a` <section class="w-full">
            <h2 class="mb-4 px-2 text-xl font-semibold">Ausbildung</h2>

            <div class="flex gap-4">
                <div class="flex-1">
                    <ptc-ui-select
                        .options=${l}
                        name="schoolEducation"
                        label="Höchster Schulabschluss"
                        @change=${(e) => {
			e.stopPropagation(), this._schoolEducation = e.detail.value, this._handleSectionChange();
		}}
                    ></ptc-ui-select>
                </div>

                <div class="flex-1">
                    <ptc-ui-select
                        .options=${u}
                        name="professionalEducation"
                        label="Höchste berufliche Ausbildung"
                        @change=${(e) => {
			e.stopPropagation(), this._professionalEducation = e.detail.value, this._handleSectionChange();
		}}
                    ></ptc-ui-select>
                </div>
            </div>
        </section>`;
	}
};
r([s({ type: Object }), n("design:type", Object)], d.prototype, "data", void 0), r([c(), n("design:type", Object)], d.prototype, "_schoolEducation", void 0), r([c(), n("design:type", Object)], d.prototype, "_professionalEducation", void 0), d = r([o("ptc-ui-employee-questionnaire-education-section")], d);
export { d as EmployeeQuestionnaireEducationSection };

//# sourceMappingURL=education-section.js.map